import { IcCashierSearch } from 'basic-ui-lib/icons';
import React from 'react';
import BaseInput from '../BaseInput';

type InputSearchProps = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
};

const InputSearch = ({ value, onChange, placeholder }: InputSearchProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };
  return (
    <BaseInput
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      prefix={<IcCashierSearch fill='#000' width={16} height={16} />}
    />
  );
};

export default InputSearch;
